/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import { RenderSections } from '@components/UI/Common/SectionCommonUI';

import MidContainer from '@Layout/MidContainer';
import BenefitsSection from '@sections/project-samskriti/BenefitsSection';
import ContactUs from '@sections/project-samskriti/ContactUs';
import Description from '@sections/project-samskriti/Description';
import Expressions from '@sections/project-samskriti/Expressions';
import PSFaqSection from '@sections/project-samskriti/FaqSection';
import LearnSection from '@sections/project-samskriti/LearnSection';
import Offerings from '@sections/project-samskriti/Offerings';
import ProgramsOffered from '@sections/project-samskriti/ProgramsOffered';
import PsUpcomingProgram from '@sections/project-samskriti/PsUpcomingProgram';
import SocialSection from '@sections/project-samskriti/SocialSection';
import StyleConfig from '../Common/StyleConfig';

/* Services */

/**
 * Renders the ProjectSamskritiUI component.
 *
 * @param pageBody.pageBody
 * @param {Array} pageBody - Content from api.
 * @param {string} region - Current User Country.
 * @param {string} lang - Current User Language.
 * @param pageBody.region
 * @param pageBody.lang
 * @returns {ReactElement} ProjectSamskritiUI Component.
 */
const ProjectSamskritiUI = ({ pageBody, region, lang }) => {
  return (
    <Box
      as="section"
      id="samskriti-section"
      className="container-article btn-center"
    >
      {pageBody && pageBody.length
        ? pageBody.map((section, i) => {
            if (section.sectionId === 'ps-expressions') {
              return (
                <Expressions
                  key={nanoid(5)}
                  sectionContent={section.sectionContent}
                />
              );
            } else if (
              section.sectionId === 'programs-offered' ||
              section.sectionId === 'ps-program-offered'
            ) {
              return (
                <StyleConfig
                  id={section?.sectionId}
                  key={section.sectionId}
                  style={section?.styleConfig}
                  bottomAngled
                >
                  <ProgramsOffered
                    key={nanoid(5)}
                    sectionContent={section.sectionContent}
                    region={region}
                    lang={lang}
                  />
                </StyleConfig>
              );
            } else if (section.sectionId === 'ps-offering-section') {
              return (
                <StyleConfig
                  id={section?.sectionId}
                  key={section.sectionId}
                  style={section?.styleConfig}
                  bottomAngled
                >
                  <Offerings
                    key={nanoid(5)}
                    sectionContent={section.sectionContent}
                    region={region}
                    lang={lang}
                  />
                </StyleConfig>
              );
            } else if (section.sectionId === 'ps-benefits-section') {
              return (
                <StyleConfig
                  id={section?.sectionId}
                  key={section.sectionId}
                  style={section?.styleConfig}
                >
                  <BenefitsSection
                    key={nanoid(5)}
                    sectionContent={section.sectionContent}
                    region={region}
                    lang={lang}
                  />
                </StyleConfig>
              );
            } else if (section.sectionId === 'ps-social-section') {
              return (
                <StyleConfig
                  id={section?.sectionId}
                  key={section.sectionId}
                  style={section?.styleConfig}
                >
                  <SocialSection
                    key={nanoid(5)}
                    section={section}
                    region={region}
                    lang={lang}
                  />
                </StyleConfig>
              );
            } else if (section.sectionId === 'ps-faq-section') {
              return (
                <StyleConfig
                  id={section?.sectionId}
                  key={section.sectionId}
                  style={section?.styleConfig}
                >
                  <PSFaqSection
                    key={nanoid(5)}
                    section={section}
                    region={region}
                    lang={lang}
                  />
                </StyleConfig>
              );
            } else if (section.sectionId === 'contact-us-ps') {
              return (
                <ContactUs
                  key={nanoid(5)}
                  sectionContent={section.sectionContent}
                  region={region}
                  lang={lang}
                />
              );
            } else if (section.sectionId === 'ps-description-section') {
              return (
                <Description
                  key={nanoid(5)}
                  sectionContent={section.sectionContent}
                  region={region}
                  lang={lang}
                />
              );
            } else if (section.sectionId === 'ps-quote-section') {
              return (
                <Box w="full" bgColor="white" p="40px 0">
                  <MidContainer>
                    <Description
                      key={nanoid(5)}
                      sectionContent={section.sectionContent}
                      region={region}
                      lang={lang}
                    />
                  </MidContainer>
                </Box>
              );
            } else if (section.sectionId === 'ps-program-register-section') {
              return (
                <PsUpcomingProgram
                  id={section.sectionId}
                  key={nanoid(5)}
                  sectionContent={section.sectionContent}
                  region={region}
                  lang={lang}
                />
              );
            } else if (section.sectionId === 'ps-learn-section') {
              return (
                <LearnSection
                  key={nanoid(5)}
                  sectionContent={section.sectionContent}
                  region={region}
                  lang={lang}
                />
              );
            } else {
              return (
                <RenderSections
                  section={section}
                  region={region}
                  lang={lang}
                  pType="others"
                  key={i}
                />
              );
            }
          })
        : null}
    </Box>
  );
};

export default ProjectSamskritiUI;
